// src/services/OcrService.js
import { BaseService } from './BaseService';

/**
 * OCR Service
 * -----------
 * • Upload a file (image / pdf / doc) to back-end `/api/ocr/upload`
 * • Back-end extracts text via Google Vision and returns `{ content }`
 * • Optional `reportType` – if it contains “ett” the back-end archives the file
 */
export class OcrService extends BaseService {
  constructor() {
    super();
  }

  /**
   * Extract text from an uploaded file.
   *
   * @param {File} file        – Image / PDF / DOCX file
   * @param {string} [reportType] – Optional reportType (ex: 'consultation', 'ett_ecg'…)
   * @returns {Promise<string>}  – Extracted text
   */
  async extractText(file, reportType) {
    if (!file) throw new Error('File is required');

    const formData = new FormData();
    formData.append('file', file);
    if (reportType) formData.append('reportType', reportType);

    // `postFormData` is provided by BaseService – handles auth headers, etc.
    const response = await this.postFormData('/ocr/upload', formData);


    return response;
  }
}